import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SET_PRICE_SUBMIT_BUTTON_ID } from "../../actions/actionsTypes";
import i18n from "../../i18nextInitiator";
import { store } from "../../store";

const useStyles = makeStyles((theme) => ({
  tooltipContainer: {
    position: "relative",
    width: "100%",
    display: "flex",
  },
  tooltipText: {
    visibility: "hidden",
    backgroundColor: "#686D76",
    color: "#fff",
    textAlign: "center",
    borderRadius: "4px",
    padding: "8px",
    position: "absolute",
    zIndex: 1,
    bottom: "125%",
    marginLeft: "-100px",
    opacity: 0,
    transition: "opacity 0.3s",
  },
  tooltipTextOne: {
    left: "48%",
    width: "200px",
  },
  tooltipTextTwo: {
    left: "36%",
    width: "265px",
  },
  tooltipTextTree: {
    left: "55%",
    width: "168px",
  },
  tooltipContainerHover: {
    "&:hover $tooltipText": {
      visibility: "visible",
      opacity: 1,
    },
  },
  button: {
    fontSize: "1rem !important",
    marginRight: "1rem !important",
    padding: "10px 22px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "4px 10px !important",
      fontSize: "1.1rem !important",
    },
  },
}));
/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");

/**
 * The continue button.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const ButtonWithLoadingCustom = (props) => {
  const {
    id,
    action,
    disabled,
    text,
    loading,
    tooltip,
    buttonsPriceCount,
    ...restProps
  } = props;
  let buttonPrice = store.getState().order.order.calc_type;
  const classes = useStyles();

  return (
    <div
      className={`${classes.tooltipContainer} ${classes.tooltipContainerHover}`}
    >
      <Button
        onClick={() => {
          store.dispatch({ type: SET_PRICE_SUBMIT_BUTTON_ID, value: id });
          action();
        }}
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        disabled={buttonPrice === id ? disabled || loading : disabled}
        className={classes.button}
        {...restProps}
      >
        {loading && buttonPrice === id ? (
          <CircularProgress color="secondary" size={25} />
        ) : (
          text ?? t("submit")
        )}
      </Button>
      <div
        className={`${classes.tooltipText} ${
          buttonsPriceCount === 3
            ? classes.tooltipTextTree
            : buttonsPriceCount === 2
            ? classes.tooltipTextTwo
            : classes.tooltipTextOne
        }`}
      >
        {tooltip}
      </div>
    </div>
  );
};

export default ButtonWithLoadingCustom;
